import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ListRecentActivitySlice = createSlice({
  name: "ListRecentActivitySlice",
  initialState: {} as IReduxState<[]>,
  reducers: {
    listRecentActivity: (state) => {
      state.isLoading = true;
    },
    successlistRecentActivity: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistRecentActivity: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistRecentActivity,
  listRecentActivity,
  successlistRecentActivity,
} = ListRecentActivitySlice.actions;

export default ListRecentActivitySlice.reducer;
